export enum PosologySchedule {
  PeriodsOfTheDay = 'periods-of-the-day',
  TimesList = 'times-list',
  Repetition = 'repetition',
  SOS = 'sos',
}
